import { ActionWithMeta, ActionWithPayload, EmptyAction } from './types';

function createAction<T extends string>(type: T): EmptyAction<T>;
function createAction<T extends string, P>(type: T, payload: P): ActionWithPayload<T, P>;
function createAction<T extends string, P, M>(type: T, payload: P, meta: M): ActionWithMeta<T, P, M>;
function createAction<T extends string, M>(type: T, payload: undefined, meta: M): ActionWithMeta<T, undefined, M>;

function createAction<T, P, M>(type: T, payload?: P, meta?: M) {
    if (typeof meta !== 'undefined') {
        return { type, payload, meta };
    }

    return { type, payload };
}

export default createAction;
